import { useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop"
import _ from "underscore"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { ToastContext } from "../../../context/ToastContext"
import { calculateWordsFromString } from "../../../utils/Helper"
import globalFilterStore from "../../../Store/globalFilterStore"

export const useRevoke = ({ stage, showPopup, apiCall }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [option, setOptions] = useState({});
    const [formValue, setFormValue] = useState({})
    const store = globalFilterStore();
    const commonFilter = store.commonFilter;

    useEffect(() => {
        callautopopulate("agile_planning_status", "declare_revoke_reasons").then((res) => {
            if (stage === "reviewing") {
                setOptions({
                    status: _.filter(res?.agile_planning_status, (item) => item?.bucket_status_key
                        === "bucket_planning" || item?.bucket_status_key === "estimating")
                })
            } else if (stage === "finalized" || stage === "estimating") {
                const opt = _.filter(res?.agile_planning_status, (item) => stage === "finalized" ? (commonFilter?.taskType ? item?.bucket_status_key === "reviewing" : item?.bucket_status_key === "bucket_planning") : item?.bucket_status_key === "bucket_planning");
                setOptions({
                    status: opt,
                    revoke_reasons: res?.declare_revoke_reasons
                })
                setFormValue((prev) => ({ ...prev, status: opt?.[0]?.bucket_status_key }));
            } else if (stage === "workspace") {
                const opt = _.filter(res?.agile_planning_status, (item) => item?.bucket_status_key === "reviewing");
                setOptions({
                    status: opt
                })
                setFormValue((prev) => ({ ...prev, status: opt?.[0]?.bucket_status_key }));
            }

        })
    }, [])

    const handleRevoke = async () => {
        try {
            if (stage === "finalized" && commonFilter?.taskType) {
                if (_.isEmpty(formValue?.selected_reason)) {
                    showInfo("Info", "Please select a reason");
                    return;
                } else if (formValue?.selected_reason?.revoke_reason?.toLowerCase() === "other" && calculateWordsFromString(formValue?.entered_reason || "") <= 5) {
                    showInfo("Info", "Your remark should contain more than 5 words");
                    return;
                }
            }
            if (!formValue?.status) {
                showInfo("Info", "Please select move stage");
                return;
            }
            const payload = {
                "issue_ids": showPopup?.data?.toString() || "",
                "product_code": showPopup?.product_code,
                "remark": formValue?.selected_reason?.revoke_reason?.toLowerCase() === "other" ? formValue?.entered_reason : formValue?.selected_reason?.revoke_reason || "",
                "rollback_key": formValue?.status,
                "is_bucket_enable": stage === "finalized" ? commonFilter?.taskType : true,
                "is_workspace": stage === "workspace"
            }
            const res = await services?.getInvokeRemote("POST", Urls("SAVEBUCKETROLLBACK"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Success', res.body.message);
                apiCall(null)
            } else {
                showError("error", res?.body?.errorMessage || res?.body?.message);
            }
        } catch (error) {
            showError("error", error?.response?.data?.errorMessage)
        }
    }

    return useMemo(() => ({
        option, handleRevoke, formValue, setFormValue, commonFilter
    }), [option, handleRevoke, formValue, setFormValue, commonFilter])
}